import { useEffect } from "react";
import PropTypes from "prop-types";
import useEventListener from "../../hooks/useEventListener";

function Matterport({ source, onSetMatterportVisible, opener }) {
    function handleBackgroundClick(e) {
        if (e.target === e.currentTarget) {
            handleMatterportClose(e);
        }
    };

    useEffect(() => {
        document.querySelector(".iframe-close-icon").focus();

        return(() => opener.focus())
    }, [opener]);

    function handleMatterportClose (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.keyCode && event.keyCode !== 13) return;

        onSetMatterportVisible(false);
    };

    function handleEscapeKey (event) {
        event.preventDefault();
        event.stopPropagation();

        if (event.keyCode === 27) {
            onSetMatterportVisible(false);
        };
    };

    useEventListener("keydown", handleEscapeKey);

    return (
        <div
            className="iframe-wrapper"
            onClick={handleBackgroundClick}
        >
            <button 
                className="iframe-close-icon" 
                onClick={event => handleMatterportClose(event)}
                onKeyDown={event => handleMatterportClose(event)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" viewBox="0 0 28 26">
                    <path fill="none" stroke="#FFFFFF" strokeWidth="4" d="M3.2,2l21.6,21.6"/>
                    <path fill="none" stroke="#FFFFFF" strokeWidth="4" d="M25,2L3,24"/>
                </svg>
            </button>

            <div className="iframe-container">
                <iframe
                    src={`${source}&play=1`}
                    title="360 view"
                    width="800"
                    height="300"
                    allowFullScreen
                />
            </div>
        </div>
    );
}

Matterport.propTypes = {
    source: PropTypes.string.isRequired,
    onSetMatterportVisible: PropTypes.func.isRequired
};

export default Matterport;
